import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";

export const RedirectModal = (props: {show: boolean, message: string|React.ReactElement, redirectUrl: string, redirectAfterSeconds?: number}) => {

	function redirect() {
		window.location.href = props.redirectUrl;
	}

	useEffect(() => {
		if (props.show && props.redirectUrl && props.redirectAfterSeconds)
			setTimeout(redirect, props.redirectAfterSeconds*1000);
	}, [props.show, props.redirectUrl, props.redirectAfterSeconds])

	return <Modal show={props.show} centered backdrop="static">
		<Modal.Body>
			{ props.message }
		</Modal.Body>
		<Modal.Footer>
			<Button variant="primary" onClick={redirect}>OK</Button>
		</Modal.Footer>

	</Modal>;
}